// Tiny battery glyph. YoLink reports battery as an integer 0..4 (empty..full).
// We render a 4-cell SVG with `level` cells filled. Color shifts to red when
// the level is at or below the low-battery threshold.

export const LOW_BATTERY_THRESHOLD = 1;

interface BatteryIndicatorProps {
  level: number; // 0..4
  className?: string;
}

export function BatteryIndicator({ level, className }: BatteryIndicatorProps) {
  const clamped = Math.max(0, Math.min(4, Math.round(level)));
  const isLow = clamped <= LOW_BATTERY_THRESHOLD;
  const fillColor = isLow ? 'var(--danger)' : 'var(--good)';
  return (
    <svg
      width="36"
      height="16"
      viewBox="0 0 36 16"
      className={className}
      role="img"
      aria-label={`Battery level ${clamped} of 4`}
    >
      <rect
        x="0.5"
        y="1.5"
        width="30"
        height="13"
        rx="2"
        ry="2"
        fill="none"
        stroke="var(--muted)"
      />
      <rect x="32" y="5" width="3" height="6" rx="1" ry="1" fill="var(--muted)" />
      {[0, 1, 2, 3].map((i) => (
        <rect
          key={i}
          x={2 + i * 7}
          y={3.5}
          width="6"
          height="9"
          fill={i < clamped ? fillColor : 'transparent'}
        />
      ))}
    </svg>
  );
}
